import React, { FunctionComponent, memo } from "react";
import { TimelineSlot } from "../../TimelineViewer/TimelineSlot/TimelineSlot";
import { SlotContent } from "../../TimelineViewer/TimelineSlot/SlotContent";
import { DynamicRenderSlot } from "../types/dynamic-viewer-types";
import { calculateDynamicPreloadDuration } from "../utils";
import { ContentFailureGenericCb } from "../../TimelineViewer/types";
import { PulseItem } from "../../../../../store/pulse/types";

interface DynamicSlotProps {
  slot: DynamicRenderSlot;
  index: number;
  zoneId: string;
  timelineItemIndex: number;
  mainTimelineId?: string;
  currentBpItem: any;
  pulseItemForZone: PulseItem | undefined;
  onContentFailure: ContentFailureGenericCb;
}

export const DynamicSlot: FunctionComponent<DynamicSlotProps> = memo(
  ({
    slot,
    index,
    zoneId,
    timelineItemIndex,
    mainTimelineId,
    currentBpItem,
    onContentFailure,
    pulseItemForZone,
  }) => {
    const indexInTimelineForSlot = timelineItemIndex;
    const shouldPreloadDynamicContentIn = slot.isPreload
      ? calculateDynamicPreloadDuration(
          currentBpItem,
          slot.item,
          pulseItemForZone
        )
      : undefined;

    return (
      <TimelineSlot
        index={index}
        key={index}
        transition={slot.item?.transition}
        isPreload={slot.isPreload}
        isActiveItemTransitioningOut={false}
        targetTimelineId={mainTimelineId}
        indexInTimeline={indexInTimelineForSlot}
        shouldPreloadDynamicContentIn={shouldPreloadDynamicContentIn}
        isDynamicContentItem={true}
      >
        {slot.item && !slot.item.isFullscreen && (
          <SlotContent
            zoneId={zoneId}
            item={slot.item}
            isPreload={slot.isPreload}
            hasNextItem={slot.hasNextItem}
            onContentFailure={onContentFailure}
            timelineItemIndex={timelineItemIndex}
          />
        )}
      </TimelineSlot>
    );
  }
);

DynamicSlot.displayName = "DynamicSlot";
